import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { AppEnv } from "../../config/env";
import type { Database } from "../../types/database";

export function createSupabaseBrowserClient(
  appEnv: AppEnv,
): SupabaseClient<Database> {
  return createClient<Database>(
    appEnv.VITE_SUPABASE_URL,
    appEnv.VITE_SUPABASE_PUBLISHABLE_KEY,
    {
      auth: {
        autoRefreshToken: true,
        detectSessionInUrl: true,
        flowType: "pkce",
        persistSession: true,
        storage:
          typeof window !== "undefined" ? window.localStorage : undefined,
      },
    },
  );
}
